import { render, staticRenderFns } from "./AssetAdjustment.vue?vue&type=template&id=60a009e2&"
import script from "./AssetAdjustment.vue?vue&type=script&lang=js&"
export * from "./AssetAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60a009e2')) {
      api.createRecord('60a009e2', component.options)
    } else {
      api.reload('60a009e2', component.options)
    }
    module.hot.accept("./AssetAdjustment.vue?vue&type=template&id=60a009e2&", function () {
      api.rerender('60a009e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/AssetAdjustment.vue"
export default component.exports